import React from "react";
import { useTranslation } from "react-i18next";
import { Button, ErrorAlert, Field, InfoField } from "src/components";
import { useDeposit } from "src/hooks";
import { formatNumberToLocale } from "src/utils";
import "./deposit-form.scss";

const DepositForm: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    amount,
    currency,
    paymentFee,
    paymentFeeLoading,
    handleAmountChange,
    handleInitiateDeposit,
    initiateDepositLoading,
    initiateDepositError,
    setAmountTouched,
    errors,
    submitDisabled,
    amountTouched,
  } = useDeposit();

  const { currency_id, precision } = currency;

  return (
    <form className="deposit-form" onSubmit={handleInitiateDeposit}>
      <Field
        label={t("DEPOSIT_FORM.AMOUNT")}
        value={amount}
        onChange={(value) => handleAmountChange(value)}
        placeholder={t("DEPOSIT_FORM.AMOUNT_PLACEHOLDER_ZERO")}
        disabled={initiateDepositLoading}
        error={amountTouched ? errors.inputErrors[0] : undefined}
        onBlur={() => setAmountTouched(true)}
      />

      <InfoField
        label={t("DEPOSIT_FORM.FEE")}
        value={`${formatNumberToLocale(paymentFee, precision)} ${currency_id}`}
        isLoading={paymentFeeLoading}
      />

      <InfoField
        label={t("DEPOSIT_FORM.RECEIVE")}
        value={`${formatNumberToLocale(Number(amount) - Number(paymentFee), precision)} ${currency_id}`}
        isLoading={paymentFeeLoading}
      />

      <ErrorAlert message={initiateDepositError} />

      <Button
        title={t("DEPOSIT_FORM.NEXT_STEP")}
        className="deposit-button"
        type="submit"
        disabled={submitDisabled}
        pending={initiateDepositLoading}
        tooltipMessage={Object.values(errors).flat()[0]}
      />
    </form>
  );
};

export default DepositForm;
